import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { FryCommonModule } from '@fry/components/common';
import { UnboxedModule } from '@fry/ui';
import { MaterialModule } from '@fry/components/material';
import { GeneralModule } from '@fry/components/general';

import {
  PaymentComponent,
  PaymentListComponent,
  RefundComponent,
  TransactionCaptureFormComponent,
  TransactionCardActionComponent,
  TransactionCardFormComponent,
  TransactionDetailsComponent,
  TransactionErrorComponent,
  TransactionInstructionsComponent,
  TransactionOutcomeComponent,
} from './components';

import { ScriptLoaderService } from '@fry/lib/utils';
import { PaymentsRoutingModule } from './payments-routing.module';
import { InteractiveTableModule } from '@fry/components/common/list/interactive-table';

@NgModule({
  imports: [
    CommonModule,
    FryCommonModule,
    GeneralModule,
    MaterialModule,
    PaymentsRoutingModule,
    ReactiveFormsModule,
    UnboxedModule,
    InteractiveTableModule,
  ],
  declarations: [
    PaymentListComponent,
    PaymentComponent,
    RefundComponent,
    TransactionCaptureFormComponent,
    TransactionCardActionComponent,
    TransactionCardFormComponent,
    TransactionDetailsComponent,
    TransactionErrorComponent,
    TransactionInstructionsComponent,
    TransactionOutcomeComponent
  ],
  exports: [
    PaymentListComponent,
    PaymentComponent,
    RefundComponent,
    TransactionCaptureFormComponent,
    TransactionCardActionComponent,
    TransactionCardFormComponent,
    TransactionDetailsComponent,
    TransactionErrorComponent,
    TransactionInstructionsComponent,
    TransactionOutcomeComponent
  ],
  providers: [
    ScriptLoaderService,
  ]
})
export class PaymentsModule {}
